module.exports = __webpack_public_path__ + "img/f1-panel-list1-1.20396e79.png";